import styled from '@emotion/styled'
import { CircularProgress } from '@mui/material'

export const StyledCircularProgress = styled(CircularProgress)(() => ({
  marginRight: '1rem',
  color: `#FFFFFF`,
}))
